import React, { useState } from "react";
import axios from "axios";
import "../styles/Regform.css";
import { Tooltip, message, Button, Select } from "antd";
import useAuth from "../hooks/useAuth";

const URL = process.env.REACT_APP_API_URL;
const Createhr = ({ closeModal }) => {

  const verticalList = [
    'Data and Digital (DnD)',
    'PACs Project (PACs)',
    'EdTech & Catalog Operations (ECO)',
    'Analytics n Insights (ANI)',
    'Adobe',
    'Shared Services',
    'Legal & Finance (LnF)',
    // 'Business Development',
    // 'Human Resources',
    // 'Administration',
    // 'IT & Governance'
  ];

  const { token } = useAuth();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    vertical: "",
    role: "",
    empCount: 0,
  });

    const roleDescriptions = {
    HR: "HR: Manages candidate records, recruitment processes, and onboarding.",
    Admin: "Admin: Has full access to manage users, roles, and system settings.",
    Panelist: "Panelist: Conducts interviews and provides feedback on candidates.",
    HiringManager: "Hiring Manager: Oversees job postings and final candidate selection."
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleVerticalChange = (vertical) => {
    const value  = vertical;
    setFormData((prevData) => ({
      ...prevData,
      vertical: value,
    }));
  };

  const handleRoleChange = (e) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      role: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const password = Math.random().toString(36).slice(-8);
    const createdAt = new Date();
    const fullName = `${formData.firstName} ${formData.lastName}`;

    if (!formData.email.endsWith("@enfuse-solutions.com")) {
      message.error('Email must end with "@enfuse-solutions.com"');
      return;
    }

    console.log("Form Data:", formData);

    try {
      const response = await axios.post(
        `${URL}/api/register/candidate`,
        {
          ...formData,
          password: password,
          createdAt: createdAt,
          confirmPassword: password,
          fullName: fullName,
        }
      );
    
      if (response.status === 201) {
        const data = response.data;
    
        // Prepare email data
        const emailData = {
          role: data.role,
          confirmPassword: data.confirmPassword,
          email: data.email,
          fullName: data.fullName,
        };
    
        // Send email
        const emailResponse = await axios.post(
          `${URL}/api/mgr/credentials`,
          emailData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
    
        if (emailResponse.status === 200) {
          message.success("User Created Successfully and Email Sent");
        } else {
          message.warning("User Created Successfully but Email Sending Failed");
        }
    
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          currentLocation: "",
          qualification: "",
          role: "",
          empCount: 0,
        });
        closeModal();
      }
    } catch (error) {
      console.error("Error creating user:", error);
      message.error("Error creating user");
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="formContainer">
          <div className="block">
            <div>
              <label htmlFor="firstName">First Name:</label>
              <br />
              <input
                type="text"
                id="firstName"
                placeholder="Enter First Name"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label htmlFor="lastName">Last Name:</label>
              <br />
              <input
                type="text"
                id="lastName"
                placeholder="Enter Last Name"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label htmlFor="email">Email:</label>
              <br />
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Please enter Enfuse Email Id only"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="block">
            <div>
              <label htmlFor="currentLocation">Current Location:</label>
              <br />
              <input
                type="text"
                id="currentLocation"
                name="currentLocation"
                placeholder="Enter Current Location"
                value={formData.currentLocation}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label htmlFor="vertical">Vertical:</label>
              <br />
                <Select
                  id="vertical"
                  name="vertical"
                  value={formData.vertical || null}
                  onChange={handleVerticalChange}
                  mode="multiple"
                  required
                > 
                 
                  {verticalList.map((ver) => (
                    <option key={ver} value={ver}>
                      {ver}
                    </option>
                  ))}
                </Select>

              {/* <input
                type="text"
                id="department"
                name="department"
                placeholder="Choose Department"
                value={formData.department}
                onChange={handleChange}
                required
              /> */}
            </div>
            <div>
              <label htmlFor="role">Role:</label>
              <br />
              <select
                id="roleSelect"
                name="role"
                value={formData.role}
                onChange={handleRoleChange}
              >
                <option>Choose Role</option>
                <option value="HR">HR</option>
                <option value="Admin">Admin</option>
                <option value="Panelist">Panelist</option>
                <option value="HiringManager">HiringManager</option>
              </select>
               {roleDescriptions[formData.role] && (
                <div style={{ marginTop: '-4px', paddingTop: '0', color: '#1a2763', fontSize: '14px' }}>
                  {roleDescriptions[formData.role]}
                </div>
              )}
            </div>
          </div>
        </div>
        <div id="btnWrapper">
          <Tooltip title="Submit" color="red">
            <Button
              type="submit"
              className="add-button"
              style={{ backgroundColor: "#A50707" }}
              onClick={handleSubmit}
            >
              Create User
            </Button>
          </Tooltip>
        </div>
      </form>
    </div>
  );
};

export default Createhr;
